import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

function purchaseLabel(purchase) {
  if (!purchase) return "";
  return [
    purchase.vehicle_number ? String(purchase.vehicle_number).toUpperCase() : null,
    purchase.code,
    purchase.party_name,
  ].filter(Boolean).join(" · ");
}

export default function SampleNotReceivedDialog({
  open,
  purchase,
  kind = "truck",
  confirming = false,
  onConfirm,
  onCancel,
}) {
  const label = purchaseLabel(purchase);
  const isComposite = kind === "composite";
  const title = isComposite
    ? `Mark composite sample not received for ${label}?`
    : `Mark sample not received for ${label}?`;
  const description = isComposite
    ? "This purchase will leave the composite queue with no report."
    : "This truck will proceed with no truck lab report.";

  return (
    <AlertDialog open={open} onOpenChange={(next) => !next && !confirming && onCancel?.()}>
      <AlertDialogContent data-testid={`${kind}-sample-not-received-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={confirming} onClick={onCancel}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={confirming}
            className="bg-bansal-sage hover:bg-bansal-sageDark text-white"
            onClick={(e) => {
              e.preventDefault();
              onConfirm?.();
            }}
          >
            {confirming ? "Saving…" : "OK"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
